import {BCMSRecord ,BCMSRecordProperty} from "bcms-react"; 
import Classes from "model";

/**
* @class Payee
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.payees[0];
* const payee = new Payee(record);
* @property {STRING} _id - The id of the payee
* @property {STRING} _name - The name of the payee
* @property {STRING} _nickname - The nickname of the payee
* @property {STRING} _account - The account name of the payee
* @property {STRING} _payeeType - The payeeType of the payee
* @property {STRING} _addressType - The addressType of the payee
* @property {STRING} _addressLine1- The addressLine1 of the payee
* @property {STRING} _addressLine2 - The addressLine2 of the payee
* @property {STRING} _city - The city of the payee
* @property {STRING} _state - The payeeType of the payee
* @property {STRING} _zip - The zip of the payee
* @property {STRING} _stateOrProvidence - The stateOrProvidence of the payee
* @property {STRING} _postalCode - The postalCode of the payee
* @property {STRING} _country - The counry of the payee
* @property {STRING} _financialInstitutionNumberType - The financialInstitutionNumberType of the payee
* @property {STRING} _financialInstitutionName - The financialInstitutionName of the payee
* @property {STRING} _financialInstitutionNumber - The financialInstitutionNumber of the payee
* @property {STRING} _financialInstitutionAddressLine1 - The financialInstitutionAddressLine1 of the payee
* @property {STRING} _financialInstitutionAddressLine2 - The financialInstitutionAddressLine2 of the payee
* @property {STRING} _financialInstitutionCity - The financialInstitutionCity of the payee
* @property {STRING} _financialInstitutionState - The financialInstitutionState of the payee
* @property {STRING} _financialInstitutionZip - The financialInstitutionZip of the payee
* @property {STRING} _financialInstitutionStateOrProvidence - The financialInstitutionStateOrProvidence of the payee
* @property {STRING} _financialInstitutionPostalCode - The financialInstitutionPostalCode of the payee
* @property {STRING} _financialInstitutionCountry - The financialInstitutionCountry of the payee
* @property {STRING} _receivingInstitutionNumberType - The receivingInstitutionNumberType of the payee
* @property {STRING} _receivingInstitutionName - The receivingInstitutionName of the payee
* @property {STRING} _receivingInstitutionNumber - The receivingInstitutionNumber of the payee
* @property {STRING} _receivingInstitutionAddressLine1 - The receivingInstitutionAddressLine1 of the payee
* @property {STRING} _receivingInstitutionAddressLine2 - The receivingInstitutionAddressLine2 of the payee
* @property {STRING} _receivingInstitutionCity - The receivingInstitutionCity of the payee
* @property {STRING} _receivingInstitutionState - The receivingInstitutionState of the payee
* @property {STRING} _receivingInstitutionZip - The receivingInstitutionZip of the payee
* @property {STRING} _receivingInstitutionStateOrProvidence - The receivingInstitutionStateOrProvidence of the payee
* @property {STRING} _receivingInstitutionPostalCode - The receivingInstitutionPostalCode of the payee
* @property {STRING} _receivingInstitutionCountry - The receivingInstitutionCountry of the payee
* @property {STRING} _intermediaryInstitutionNumberType - The intermediaryInstitutionNumberType of the payee
* @property {STRING} _intermediaryInstitutionName - The intermediaryInstitutionName of the payee
* @property {STRING} _intermediaryInstitutionNumber - The intermediaryInstitutionNumber of the payee
* @property {STRING} _intermediaryInstitutionAddressLine1 - The intermediaryInstitutionAddressLine1 of the payee
* @property {STRING} _intermediaryInstitutionAddressLine2 - The intermediaryInstitutionAddressLine2 of the payee
* @property {STRING} _intermediaryInstitutionCity - The intermediaryInstitutionCity of the payee
* @property {STRING} _intermediaryInstitutionState - The intermediaryInstitutionState of the payee
* @property {STRING} _intermediaryInstitutionZip - The intermediaryInstitutionZip of the payee
* @property {STRING} _intermediaryInstitutionStateOrProvidence - The intermediaryInstitutionStateOrProvidence of the payee
* @property {STRING} _intermediaryInstitutionPostalCode - The intermediaryInstitutionPostalCode of the payee
* @property {STRING} _intermediaryInstitutionCountry - The intermediaryInstitutionCountry of the payee
* @property {BOOLEAN} _requiresReceivingFinancialInstitutionDetails - The requiresReceivingFinancialInstitutionDetails of the payee
* @property {BOOLEAN} _requiresIntermediaryFinancialInstitutionDetails - The requiresIntermediaryFinancialInstitutionDetails of the payee
*/
export default class Payee extends BCMSRecord {
    _id
    _name
    _nickname
    _account
    _payeeType
    _addressType
    _addressLine1
    _addressLine2
    _city
    _state
    _zip
    _stateOrProvidence
    _postalCode
    _country

    _financialInstitutionNumberType
    _financialInstitutionName
    _financialInstitutionNumber
    _financialInstitutionAddressLine1
    _financialInstitutionAddressLine2
    _financialInstitutionCity
    _financialInstitutionState
    _financialInstitutionZip
    _financialInstitutionStateOrProvidence
    _financialInstitutionPostalCode
    _financialInstitutionCountry

    _receivingInstitutionNumberType
    _receivingInstitutionName
    _receivingInstitutionNumber
    _receivingInstitutionAddressLine1
    _receivingInstitutionAddressLine2
    _receivingInstitutionCity
    _receivingInstitutionState
    _receivingInstitutionZip
    _receivingInstitutionStateOrProvidence
    _receivingInstitutionPostalCode
    _receivingInstitutionCountry

    _intermediaryInstitutionNumberType
    _intermediaryInstitutionName
    _intermediaryInstitutionNumber
    _intermediaryInstitutionAddressLine1
    _intermediaryInstitutionAddressLine2
    _intermediaryInstitutionCity
    _intermediaryInstitutionState
    _intermediaryInstitutionZip
    _intermediaryInstitutionStateOrProvidence
    _intermediaryInstitutionPostalCode
    _intermediaryInstitutionCountry

    _requiresReceivingFinancialInstitutionDetails
    _requiresIntermediaryFinancialInstitutionDetails

    constructor(record) {     
      super(record) 
    }
  }
  Payee.define({
    "recordType":"payees",
    "recordIDProp":"id",
    "className" : "Payee",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id 
       * @property set {NUMBER} - sets the id 
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("id","_id"),
      /** 
       * @name name
       * @instance
       * @property get {STRING} - gets the name
       * @property set {STRING} - sets the name
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("name","_name"),
      /** 
       * @name nickname
       * @instance
       * @property get {STRING} - gets the nickname
       * @property set {STRING} - sets the nickname
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("nickname","_nickname"),
      /** 
       * @name account
       * @instance
       * @property get {STRING} - gets the account
       * @property set {STRING} - sets the account
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("account","_account"), // may be converted to an account class later on.
      /** 
       * @name payeeType
       * @instance
       * @property get {STRING} - gets the payeeType
       * @property set {STRING} - sets the payeeType
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("payeeType","_payeeType"),
      /** 
       * @name addressType
       * @instance
       * @property get {STRING} - gets the addressType
       * @property set {STRING} - sets the addressType
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("addressType","_addressType"),
      /** 
       * @name addressLine1
       * @instance
       * @property get {STRING} - gets the addressLine1
       * @property set {STRING} - sets the addressLine1
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("addressLine1","_addressLine1"),
      /** 
       * @name addressLine2
       * @instance
       * @property get {STRING} - gets the addressLine2
       * @property set {STRING} - sets the addressLine2
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("addressLine2","_addressLine2"),
      /** 
       * @name city
       * @instance
       * @property get {STRING} - gets the city
       * @property set {STRING} - sets the city
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("city","_city"),
      /** 
       * @name state
       * @instance
       * @property get {STRING} - gets the state
       * @property set {STRING} - sets the state
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("state","_state"),
      /** 
       * @name zip
       * @instance
       * @property get {STRING} - gets the zip
       * @property set {STRING} - sets the zip
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("zip","_zip"),
      /** 
       * @name financialInstitutionNumberType
       * @instance
       * @property get {STRING} - gets the financialInstitutionNumberType
       * @property set {STRING} - sets the financialInstitutionNumberType
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("financialInstitutionNumberType","_financialInstitutionNumberType"),
      /** 
       * @name financialInstitutionName
       * @instance
       * @property get {STRING} - gets the financialInstitutionName
       * @property set {STRING} - sets the financialInstitutionName
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("financialInstitutionName","_financialInstitutionName"),
      /** 
       * @name financialInstitutionNumber
       * @instance
       * @property get {STRING} - gets the financialInstitutionNumber
       * @property set {STRING} - sets the financialInstitutionNumber
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("financialInstitutionNumber","_financialInstitutionNumber"),
      /** 
       * @name financialInstitutionAddressLine1
       * @instance
       * @property get {STRING} - gets the financialInstitutionAddressLine1
       * @property set {STRING} - sets the financialInstitutionAddressLine1
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("financialInstitutionAddressLine1","_financialInstitutionAddressLine1"),
      /** 
       * @name financialInstitutionAddressLine2
       * @instance
       * @property get {STRING} - gets the financialInstitutionAddressLine2
       * @property set {STRING} - sets the financialInstitutionAddressLine2
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("financialInstitutionAddressLine2","_financialInstitutionAddressLine2"),
      /** 
       * @name financialInstitutionCity
       * @instance
       * @property get {STRING} - gets the financialInstitutionCity
       * @property set {STRING} - sets the financialInstitutionCity
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("financialInstitutionCity","_financialInstitutionCity"),
      /** 
       * @name financialInstitutionState
       * @instance
       * @property get {STRING} - gets the financialInstitutionState
       * @property set {STRING} - sets the financialInstitutionState
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("financialInstitutionState","_financialInstitutionState"),
      /** 
       * @name financialInstitutionZip
       * @instance
       * @property get {STRING} - gets the financialInstitutionZip
       * @property set {STRING} - sets the financialInstitutionZip
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("financialInstitutionZip","_financialInstitutionZip"),
      /** 
       * @name financialInstitutionStateOrProvidence
       * @instance
       * @property get {STRING} - gets the financialInstitutionStateOrProvidence
       * @property set {STRING} - sets the financialInstitutionStateOrProvidence
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("financialInstitutionStateOrProvidence","_financialInstitutionStateOrProvidence"),
      /** 
       * @name financialInstitutionPostalCode
       * @instance
       * @property get {STRING} - gets the financialInstitutionPostalCode
       * @property set {STRING} - sets the financialInstitutionPostalCode
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("financialInstitutionPostalCode","_financialInstitutionPostalCode"),
      /** 
       * @name financialInstitutionCountry
       * @instance
       * @property get {STRING} - gets the financialInstitutionCountry
       * @property set {STRING} - sets the financialInstitutionCountry
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("financialInstitutionCountry","_financialInstitutionCountry"),
      /** 
       * @name receivingInstitutionNumberType
       * @instance
       * @property get {STRING} - gets the receivingInstitutionNumberType
       * @property set {STRING} - sets the receivingInstitutionNumberType
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("receivingInstitutionNumberType","_receivingInstitutionNumberType"),
      /** 
       * @name receivingInstitutionName
       * @instance
       * @property get {STRING} - gets the receivingInstitutionName
       * @property set {STRING} - sets the receivingInstitutionName
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("receivingInstitutionName","_receivingInstitutionName"),
      /** 
       * @name receivingInstitutionNumber
       * @instance
       * @property get {STRING} - gets the receivingInstitutionNumber
       * @property set {STRING} - sets the receivingInstitutionNumber
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("receivingInstitutionNumber","_receivingInstitutionNumber"),
      /** 
       * @name receivingInstitutionAddressLine1
       * @instance
       * @property get {STRING} - gets the receivingInstitutionAddressLine1
       * @property set {STRING} - sets the receivingInstitutionAddressLine1
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("receivingInstitutionAddressLine1","_receivingInstitutionAddressLine1"),
      /** 
       * @name receivingInstitutionAddressLine2
       * @instance
       * @property get {STRING} - gets the receivingInstitutionAddressLine2
       * @property set {STRING} - sets the receivingInstitutionAddressLine2
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("receivingInstitutionAddressLine2","_receivingInstitutionAddressLine2"),
      /** 
       * @name receivingInstitutionCity
       * @instance
       * @property get {STRING} - gets the receivingInstitutionCity
       * @property set {STRING} - sets the receivingInstitutionCity
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("receivingInstitutionCity","_receivingInstitutionCity"),
      /** 
       * @name receivingInstitutionState
       * @instance
       * @property get {STRING} - gets the receivingInstitutionState
       * @property set {STRING} - sets the receivingInstitutionState
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("receivingInstitutionState","_receivingInstitutionState"),
      /** 
       * @name receivingInstitutionZip
       * @instance
       * @property get {STRING} - gets the receivingInstitutionZip
       * @property set {STRING} - sets the receivingInstitutionZip
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("receivingInstitutionZip","_receivingInstitutionZip"),
      /** 
       * @name receivingInstitutionStateOrProvidence
       * @instance
       * @property get {STRING} - gets the receivingInstitutionStateOrProvidence
       * @property set {STRING} - sets the receivingInstitutionStateOrProvidence
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("receivingInstitutionStateOrProvidence","_receivingInstitutionStateOrProvidence"),
      /** 
       * @name receivingInstitutionPostalCode
       * @instance
       * @property get {STRING} - gets the receivingInstitutionPostalCode
       * @property set {STRING} - sets the receivingInstitutionPostalCode
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("receivingInstitutionPostalCode","_receivingInstitutionPostalCode"),
      /** 
       * @name receivingInstitutionCountry
       * @instance
       * @property get {STRING} - gets the receivingInstitutionCountry
       * @property set {STRING} - sets the receivingInstitutionCountry
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("receivingInstitutionCountry","_receivingInstitutionCountry"),
      /** 
       * @name intermediaryInstitutionNumberType
       * @instance
       * @property get {STRING} - gets the intermediaryInstitutionNumberType
       * @property set {STRING} - sets the intermediaryInstitutionNumberType
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("intermediaryInstitutionNumberType","_intermediaryInstitutionNumberType"),
      /** 
       * @name intermediaryInstitutionName
       * @instance
       * @property get {STRING} - gets the intermediaryInstitutionName
       * @property set {STRING} - sets the intermediaryInstitutionName
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("intermediaryInstitutionName","_intermediaryInstitutionName"),
      /** 
       * @name intermediaryInstitutionNumber
       * @instance
       * @property get {STRING} - gets the intermediaryInstitutionNumber
       * @property set {STRING} - sets the intermediaryInstitutionNumber
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("intermediaryInstitutionNumber","_intermediaryInstitutionNumber"),
      /** 
       * @name intermediaryInstitutionAddressLine1
       * @instance
       * @property get {STRING} - gets the intermediaryInstitutionAddressLine1
       * @property set {STRING} - sets the intermediaryInstitutionAddressLine1
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("intermediaryInstitutionAddressLine1","_intermediaryInstitutionAddressLine1"),
      /** 
       * @name intermediaryInstitutionAddressLine2
       * @instance
       * @property get {STRING} - gets the intermediaryInstitutionAddressLine2
       * @property set {STRING} - sets the intermediaryInstitutionAddressLine2
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("intermediaryInstitutionAddressLine2","_intermediaryInstitutionAddressLine2"),
      /** 
       * @name intermediaryInstitutionCity
       * @instance
       * @property get {STRING} - gets the intermediaryInstitutionCity
       * @property set {STRING} - sets the intermediaryInstitutionCity
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("intermediaryInstitutionCity","_intermediaryInstitutionCity"),
      /** 
       * @name intermediaryInstitutionState
       * @instance
       * @property get {STRING} - gets the intermediaryInstitutionState
       * @property set {STRING} - sets the intermediaryInstitutionState
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("intermediaryInstitutionState","_intermediaryInstitutionState"),
      /** 
       * @name intermediaryInstitutionZip
       * @instance
       * @property get {STRING} - gets the intermediaryInstitutionZip
       * @property set {STRING} - sets the intermediaryInstitutionZip
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("intermediaryInstitutionZip","_intermediaryInstitutionZip"),
      /** 
       * @name intermediaryInstitutionStateOrProvidence
       * @instance
       * @property get {STRING} - gets the intermediaryInstitutionStateOrProvidence
       * @property set {STRING} - sets the intermediaryInstitutionStateOrProvidence
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("intermediaryInstitutionStateOrProvidence","_intermediaryInstitutionStateOrProvidence"),
      /** 
       * @name intermediaryInstitutionPostalCode
       * @instance
       * @property get {STRING} - gets the intermediaryInstitutionPostalCode
       * @property set {STRING} - sets the intermediaryInstitutionPostalCode
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("intermediaryInstitutionPostalCode","_intermediaryInstitutionPostalCode"),
      /** 
       * @name intermediaryInstitutionCountry
       * @instance
       * @property get {STRING} - gets the intermediaryInstitutionCountry
       * @property set {STRING} - sets the intermediaryInstitutionCountry
       * @memberof Payee
       */
      BCMSRecordProperty.mapToString("intermediaryInstitutionCountry","_intermediaryInstitutionCountry"),
      /** 
       * @name requiresReceivingFinancialInstitutionDetails
       * @instance
       * @property get {STRING} - gets the receivingInstitutionZip
       * @property set {STRING} - sets the receivingInstitutionZip
       * @memberof Payee
       */
      BCMSRecordProperty.mapToBoolean("requiresReceivingFinancialInstitutionDetails","_requiresReceivingFinancialInstitutionDetails"),
      /** 
       * @name requiresIntermediaryFinancialInstitutionDetails
       * @instance
       * @property get {STRING} - gets the requiresIntermediaryFinancialInstitutionDetails
       * @property set {STRING} - sets the requiresIntermediaryFinancialInstitutionDetails
       * @memberof Payee
       */
      BCMSRecordProperty.mapToBoolean("requiresIntermediaryFinancialInstitutionDetails","_requiresIntermediaryFinancialInstitutionDetails"),
    ]  
})




